import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function OtherRetributionsIcon({ className }: IconProps) {
  return (
    <svg
      width="78"
      height="78"
      viewBox="0 0 78 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_610)">
        <path
          d="M69.0655 78V3.53902C69.0655 1.58076 67.4818 0 65.52 0H3.54545C1.58364 0 0 1.58076 0 3.53902V68.5154C0 73.7532 4.25455 78 9.50182 78H69.0655Z"
          fill="#EAEDF8"
        />
        <path
          d="M9.62012 78.0001C14.2056 78.0001 18.011 74.6026 18.6019 70.1906C18.6965 69.4828 19.2874 68.9402 19.9965 68.9402H76.5583C77.4565 68.9402 78.1183 69.7424 77.9529 70.6153C77.1729 74.815 73.4619 78.0001 69.0183 78.0001H9.62012Z"
          fill="#00C4B3"
        />
        <path
          d="M13.9692 27.5337H16.3801C16.8292 27.5337 17.1838 27.8876 17.1838 28.3359V42.7043C17.1838 43.1526 16.8292 43.5065 16.3801 43.5065H13.9692C12.1965 43.5065 10.7783 42.0673 10.7783 40.3214V30.7424C10.7783 28.9729 12.2201 27.5573 13.9692 27.5573"
          fill="#00416B"
        />
        <path
          d="M19.6889 27.1797L33.6344 17.6952C34.958 16.7986 36.7544 17.7423 36.7544 19.3467V51.7169C36.7544 53.3213 34.958 54.265 33.6344 53.3685L19.6889 43.8839C19.358 43.6716 19.1689 43.2941 19.1689 42.893V28.1943C19.1689 27.7932 19.358 27.4393 19.6889 27.2033"
          fill="#00C4B3"
        />
        <path
          d="M50.6996 17.8131C51.0069 17.8131 51.3141 17.9311 51.5505 18.167C56.2069 22.815 58.7596 28.9729 58.7596 35.5318C58.7596 42.0908 56.2069 48.2487 51.5505 52.873C51.0778 53.3449 50.3214 53.3449 49.8487 52.873C49.376 52.4012 49.376 51.6462 49.8487 51.1743C54.0323 46.9983 56.3487 41.4302 56.3487 35.5082C56.3487 29.5863 54.0323 24.0418 49.8487 19.8422C49.376 19.3703 49.376 18.6153 49.8487 18.1435C50.085 17.9075 50.3923 17.7896 50.6996 17.7896"
          fill="#00416B"
        />
        <path
          d="M46.1381 23.334C46.4453 23.334 46.7526 23.452 46.989 23.6879C53.5363 30.2233 53.5363 40.8639 46.989 47.3993C46.5163 47.8712 45.7599 47.8712 45.2872 47.3993C44.8144 46.9275 44.8144 46.1725 45.2872 45.7006C50.889 40.1089 50.889 30.9783 45.2872 25.3866C44.8144 24.9147 44.8144 24.1598 45.2872 23.6879C45.5235 23.452 45.8308 23.334 46.1381 23.334Z"
          fill="#00416B"
        />
        <path
          d="M41.5531 28.8313C41.8604 28.8313 42.1677 28.9493 42.404 29.1852C45.9022 32.677 45.9022 38.3867 42.404 41.8785C41.9313 42.3504 41.1749 42.3504 40.7022 41.8785C40.2295 41.4066 40.2295 40.6516 40.7022 40.1798C41.9549 38.9293 42.6404 37.2778 42.6404 35.5318C42.6404 33.7859 41.9549 32.1108 40.7022 30.8839C40.2295 30.4121 40.2295 29.6571 40.7022 29.1852C40.9386 28.9493 41.2458 28.8313 41.5531 28.8313Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_610">
          <rect width="78" height="78" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
